import * as RadixContextMenu from '@radix-ui/react-context-menu';
import classNames from 'classnames';
import { memo, type ReactNode } from 'react';

import { CheckIcon } from '@air/design-icons';
import { tailwindVariants } from '@air/utils-tailwind';

import { type ContextMenuItemVariant, contextMenuItem } from './ContextMenuItem';

export const contextMenuRadioItem = tailwindVariants({
  base: 'justify-between',
  extend: contextMenuItem,
});

export type ContextMenuRadioItemProps = Omit<RadixContextMenu.ContextMenuRadioItemProps, 'prefix'> &
  Omit<ContextMenuItemVariant, 'description'> & {
    description?: ReactNode;
    label?: ReactNode;
    prefix?: ReactNode;
  };

export const ContextMenuRadioItem = memo(
  ({ children, className, description, label, prefix, ...restOfProps }: ContextMenuRadioItemProps) => {
    const hasDescription = !!description;

    return (
      <RadixContextMenu.RadioItem className={contextMenuRadioItem({ className })} {...restOfProps}>
        {children ? (
          children
        ) : (
          <>
            {prefix ? (
              <div className={classNames('mr-2 shrink-0', hasDescription ? 'mt-0.5' : 'mt-0')}>{prefix}</div>
            ) : null}

            <div className="flex min-w-0 grow flex-col">
              <span className="truncate text-14">{label}</span>
              {hasDescription ? <span className="text-12 text-gray-8">{description}</span> : null}
            </div>
          </>
        )}

        <RadixContextMenu.ItemIndicator className={classNames('ml-2 shrink-0', hasDescription ? 'mt-0.5' : 'mt-0')}>
          <CheckIcon size="sm" />
        </RadixContextMenu.ItemIndicator>
      </RadixContextMenu.RadioItem>
    );
  },
);

ContextMenuRadioItem.displayName = 'ContextMenuRadioItem';
